import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SidebarService {
  // TODO: Make this an enum
  // Fully opened = 0
  // Partially open (icons visible) = 1
  // Closed = 2
  sidebarState: Number;

  private client = new BehaviorSubject<any>(false);
  clientUpdated = this.client.asObservable();
  ignorePageRefresh: boolean = false;
  
  // user$: Observable<User>;
  // private userSubject: Subject<User>;

  constructor() {
    this.sidebarState = 0;
    // this.userSubject = new Subject<User>();
    // this.user$ = this.userSubject.asObservable();
  }

  open() {
    this.sidebarState = 0;
  }

  openPartial() {
    this.sidebarState = 1;
  }

  close() {
    this.sidebarState = 2;
  }

  setClientUpdate(isUpdating: boolean) {
    this.client.next(isUpdating);
  }

  pushUpdatesToClient(fromPageToSideNav: boolean){
    if(fromPageToSideNav){
      this.client.next(true);
    }
  }
}